import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [agent, setAgent]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('hd_agent');
    if (stored) setAgent(JSON.parse(stored));
    setLoading(false);
  }, []);

  function login(agentData, token) {
    localStorage.setItem('hd_token', token);
    localStorage.setItem('hd_agent', JSON.stringify(agentData));
    setAgent(agentData);
  }

  function logout() {
    localStorage.removeItem('hd_token');
    localStorage.removeItem('hd_agent');
    setAgent(null);
  }

  return (
    <AuthContext.Provider value={{ agent, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
